import { TextField } from "@mui/material";
import { styled } from "@mui/material/styles";

const PREFIX = "TextFieldStyled";

export const textFieldStyledClasses = {
  root: `${PREFIX}-root`,
  select: `${PREFIX}-select`,
  inputClearButton: `${PREFIX}-inputClearButton`,
};

export const TextFieldStyled = styled(TextField)(() => ({
  [`&.${textFieldStyledClasses.root}`]: {
    [`& .${textFieldStyledClasses.select}`]: {
      [`& .${textFieldStyledClasses.inputClearButton}`]: {
        display: "none",
      },
      "&:hover, &:focus, &:focus-within": {
        [`& .${textFieldStyledClasses.inputClearButton}`]: {
          display: "flex",
        },
      },
    },
  },
}));
